import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';

declare var MachnetWidget: any;
@Component({
  selector: 'app-verify-document',
  templateUrl: './verify-document.component.html',
  styleUrls: ['./verify-document.component.scss']
})
export class VerifyDocumentComponent implements OnInit {

  constructor(public auth:AuthService,private messageService: MessageService,public common:CommonService,public router:Router) { }

  ngOnInit(): void {
    if(!this.auth.user.verified){
      this.common.showLoader()
      this.auth.getWidgetToken().subscribe((res:any)=>{
        //console.log(res)
        this.addScript(this.auth.user.uuid,res.token)
      this.common.stopLoader()
      },err=>{
        let errorKeys = Object.keys(err.error.errors); 
        errorKeys.forEach(key => { 
          //console.log(key)
          let value = err.error.errors[key][0]; 
          this.messageService.add({severity:'error', summary:value, detail:""});
          //console.log(value); 
      }); 
        //console.log(err)
        this.common.stopLoader()
      })
    }
  }

  addScript(senderid,token){
    var widget = new MachnetWidget({
      elementId: "widget-root",
      senderId: senderid,
      width: "100%",
      height: "200px",
      type: "kyc",
      locale: "en",
      multiStep: true,
      //stylesheet: "https://example.com/mystyle.css",
      token: token,
    });
    widget.init();
    window.addEventListener("message", function (e) {
      //console.log("type", e.data.type)
      //console.log("all_detail", e.data)
      //console.log("all", e)
      if(e.data.status === "VERIFIED"){
        this.verifyAccount()
      }
    }.bind(this))
  }

  verifyAccount(){
    //console.log("verifing")
    this.auth.verifyUser().subscribe(res=>{
      // this.messageService.add({severity:'success', summary:'Successful', detail:"Successfully Verified Doccuments"});
      this.auth.setUser()
      this.router.navigateByUrl("/manage-payment-methods")
    },err=>{
      this.messageService.add({severity:'error', summary:'Some Error Occoured', detail:""});
    })
  }

}
